import { render, staticRenderFns } from "./DiffCardSetting.vue?vue&type=template&id=3b983aba&scoped=true"
import script from "./DiffCardSetting.vue?vue&type=script&lang=ts"
export * from "./DiffCardSetting.vue?vue&type=script&lang=ts"
import style0 from "./DiffCardSetting.vue?vue&type=style&index=0&id=3b983aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b983aba",
  null
  
)

export default component.exports